import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight, faFileShield } from '@fortawesome/free-solid-svg-icons'
import CustomInput from './custom-input'
import CustomButton from './custom-button'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

const EnterChaseNumber: React.FC = () => {
    const [policyNumber, setPolicyNumber] = useState<string>()
    const navigate = useNavigate()


    const Navigate = () => {
        if (policyNumber) {
            navigate(`/${policyNumber}`)
        } else {
            toast.error("Please eneter Policy Refrence Number")
        }
    }

    return (
        <div className="w-full max-w-[460px] surface-card px-5 py-8 sm:px-9 sm:py-10 animate-drop-in">
            <div className='flex flex-col items-center justify-center'>
                <span className='w-16 h-16 rounded-2xl bg-tile flex items-center justify-center'>
                    <FontAwesomeIcon icon={faFileShield} className='text-white text-[26px]' />
                </span>
                <h2 className='text-white text-heroSM sm:text-hero mt-5 mb-4 text-center'>Enter Policy Refrence Number</h2>

                <CustomInput name='polciyNumber' aria-label='Policy reference number' className='text-center font-code font-bold tracking-[0.08em]' onChange={(e) => setPolicyNumber(e.target.value)} />

                <CustomButton className='mt-4' onClick={Navigate}>
                    View Chase <FontAwesomeIcon icon={faArrowRight} className='text-[14px]' />
                </CustomButton>
            </div>
        </div>
    )
}

export default EnterChaseNumber
